/**
 * Canonical cancer-type values for patient intake dropdowns.
 * URL condition / cancer_type params are mapped onto these keys.
 */

export const CANCER_TYPE_OPTIONS = [
  { value: 'breast', label: 'Breast Cancer' },
  { value: 'lung', label: 'Lung Cancer' },
  { value: 'colorectal', label: 'Colorectal Cancer' },
  { value: 'prostate', label: 'Prostate Cancer' },
  { value: 'melanoma', label: 'Melanoma' },
  { value: 'multiple_myeloma', label: 'Multiple Myeloma' },
  { value: 'leukemia', label: 'Leukemia' },
  { value: 'lymphoma', label: 'Lymphoma' },
  { value: 'pancreatic', label: 'Pancreatic Cancer' },
  { value: 'ovarian', label: 'Ovarian Cancer' },
  { value: 'bladder', label: 'Bladder Cancer' },
  { value: 'kidney', label: 'Kidney Cancer' },
  { value: 'sarcoma', label: 'Sarcoma' },
  { value: 'brain', label: 'Brain Tumors' },
  { value: 'other', label: 'Other / Not Listed' },
];

const ALIASES = {
  multiple_myeloma: 'multiple_myeloma',
  'multiple-myeloma': 'multiple_myeloma',
  multiplemyeloma: 'multiple_myeloma',
  myeloma: 'multiple_myeloma',
  mm: 'multiple_myeloma',
  'multiple myeloma': 'multiple_myeloma',
  'brain tumor': 'brain',
  'brain tumors': 'brain',
  'brain cancer': 'brain',
  glioblastoma: 'brain',
};

export function canonicalizeCancerType(raw) {
  const value = String(raw || '').trim();
  if (!value) return null;
  const lowered = value.toLowerCase().replace(/[_-]+/g, ' ').replace(/\s+/g, ' ').trim();
  const compact = lowered.replace(/\s+/g, '_');
  const hyphen = lowered.replace(/\s+/g, '-');
  const mapped = ALIASES[compact] || ALIASES[hyphen] || ALIASES[lowered] || ALIASES[value.toLowerCase()];
  if (mapped) return mapped;
  const match = CANCER_TYPE_OPTIONS.find((option) => (
    option.value === compact
    || option.value === value.toLowerCase()
    || option.label.toLowerCase() === lowered
  ));
  return match?.value || null;
}

export function cancerTypeLabel(value) {
  const canonical = canonicalizeCancerType(value) || value;
  return CANCER_TYPE_OPTIONS.find((option) => option.value === canonical)?.label || canonical || null;
}
